// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioButton_root","input":"RadioButton_input","label":"RadioButton_label"};